import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";
import { LINE_COLORS } from "../types/Config";


export default class LineManager {
	helperLines = [new Line(), new Line()]
	lines = LINE_COLORS.map(color => new Line({ color }));

	constructor() {
		rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll())
	}
	clearAll = () => this.lines.forEach(l => l.clear());
	draw(chordCoordsArr: Coord[][], intersecCoord: Coord) {
		const pointsCoord = [chordCoordsArr[0][0], chordCoordsArr[0][2], chordCoordsArr[1][0], chordCoordsArr[1][2]]
		this.lines.forEach((l, lI) => l.draw(intersecCoord, pointsCoord[lI]));
	}
}